module.exports = __webpack_public_path__ + "static/media/ic_check_valid.36141be4.svg";